import { createContext } from 'react';

const MenuContext = createContext([]);

export default MenuContext;